<template>
  <div
    class="mb-2 flex cursor-pointer rounded-sm border p-2"
    :class="{ 'border-primary': active }"
  >
    {{ name }}
  </div>
</template>

<script setup lang="ts">
defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    required: true,
  },
});
</script>
